import { View } from "binder"
import { FilesListViewModel } from "./filesList-viewModel"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";

export class FilesListView extends FormBuilderComponentView<FilesListViewModel>{
    GetViewUniqueId(): string {
        return "V-32E0F08D-353A-4F58-A259-E7CEAF81691E"
    }
    loadHtml(): string {
        let element = require('./filesList.html').default;
        let style = require('./filesList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set IsReadOnly(v: boolean) { this._IsReadOnly = v; } public get IsReadOnly(): boolean { return this._IsReadOnly;} private _IsReadOnly: boolean;
    public set IsSingle(v: boolean) { this._IsSingle = v; } public get IsSingle(): boolean { return this._IsSingle;} private _IsSingle: boolean;
    public set SingleFileMaxSize(v: number) { this._SingleFileMaxSize = v; } public get SingleFileMaxSize(): number { return this._SingleFileMaxSize;} private _SingleFileMaxSize: number;
    public set FilesData(v: any) { this._FilesData = v; } public get FilesData(): any { return this._FilesData;} private _FilesData: any;
    
}
